// extracted by mini-css-extract-plugin
module.exports = {"content":"Summary_content__2x-yY"};